<template>
  <div>
    <div class="flex items-center mb-2 ml-4 gap-y-3" :class="{ 'justify-between': showBtn, 'justify-end': !showBtn }">
      <div class="flex items-center gap-3 min-w-0">
        <el-form>
          <el-form-item v-if="pageStatus == 1 && (this.userInfo.role == 4 || this.userInfo.role == 5)"
            label="Vetting Request Date" prop="vettingRequestDate" class="mb-0" size="mini"
            :class="{ 'ml-16': isMobileScreen, '': !isMobileScreen }">
            <el-select v-model="vettingRequestDate" :style="{ width: isMobileScreen ? '170px' : '220px' }">
              <el-option v-for="date in vettingRequestDates" :key="date" :label="date" :value="date" />
            </el-select>
          </el-form-item>
        </el-form>

        <div class="flex items-center gap-2 shrink-0">
          <el-button size="mini" type="primary" v-if="canSaveInfo" @click="handleSaveClickTerminal">
            Save Ship Informations
          </el-button>
          <el-button size="mini" type="primary" v-if="canUseOcr" :loading="ocrUploading" @click="openOcrDialog">
            Upload OCR
          </el-button>
        </div>
      </div>

      <div class="flex items-center justify-end gap-y-2 flex-1 flex-wrap">
        <template v-if="showBtn">
          <el-button size="mini" @click="handleCloseClick">Close</el-button>

          <el-button size="mini" type="primary" v-if="submitToTerminalBtn" @click="handleStatusButtonClick(0)">
            Submit To Terminal Approval
          </el-button>
          <el-button size="mini" type="primary" v-if="resubmitChangesBtn" @click="handleStatusButtonClick(1)">
            Resubmit Changes
          </el-button>
          <el-button size="mini" type="primary" v-if="submitBtn" @click="confirmToSubmitDialog = true">
            Submit
          </el-button>

          <el-button size="mini" type="success" v-if="acceptBtn" @click="handleStatusButtonClick(6)">Accept</el-button>
          <el-button size="mini" type="danger" v-if="rejectBtn"
            @click="terminalReqRemarkDialog = true">Reject</el-button>

          <el-button size="mini" type="primary" v-if="submitToInspectionBtn" @click="handleStatusButtonClick(2)">
            Submit for Inspection
          </el-button>
          <el-button size="mini" type="primary" v-if="pendingObsBtn" @click="handleStatusButtonClick(12)">
            Pending Observation
          </el-button>
          <el-button size="mini" type="primary" v-if="anchorageInspectionBtn" @click="handleStatusButtonClick(4)">
            Anchorage Inspection
          </el-button>
          <el-button size="mini" type="primary" v-if="moreInfoRequiredBtn" @click="logisticsRemarksDialog = true">
            More Information Required
          </el-button>
          <el-button size="mini" type="primary" v-if="suspendedBtn" @click="suspendedDialog = true">Suspend</el-button>
          <el-button size="mini" type="danger" v-if="deleteBtn" @click="confirmToDeleteDialog = true">Delete</el-button>

          <span class="mx-3"
            :class="{ 'whitespace-nowrap': !isMobileScreen, 'whitespace-wrap text-xs': isMobileScreen }"
            :style="{ fontSize: '12px', color: getStatusColor(this.requestData.shipStatus || this.requestData.status) }">
            {{ getShipVetStatus() }}
          </span>
        </template>

        <template v-else>
          <el-button size="mini" type="primary" v-if="saveBtn" @click="handleSaveClick">Save</el-button>
          <el-button size="mini" type="primary" v-if="pendingObsBtn" @click="handleStatusButtonClick(13)">
            Pending Observation
          </el-button>
          <el-button size="mini" type="primary" v-if="submitToInspectionBtn" @click="handleStatusButtonClick(11)">
            Submit for Inspection
          </el-button>
          <el-button size="mini" @click="handleCloseClick">Close</el-button>
          <el-button size="mini" type="primary" v-if="ocrBtn" :loading="ocrUploading" @click="openOcrDialog">
            Upload OCR
          </el-button>

          <span class="mx-3"
            :class="{ 'whitespace-nowrap': !isMobileScreen, 'whitespace-wrap text-xs': isMobileScreen }"
            :style="{ fontSize: '12px', color: getStatusColor(this.requestData.shipStatus || this.requestData.status) }">
            {{ getShipVetStatus() }}
          </span>
        </template>
      </div>
    </div>
    <div class="flex"
      :style="{ flexDirection: isMobileScreen ? 'column' : 'row', marginRight: isMobileScreen ? '0px' : '0', marginBottom: isMobileScreen ? '20px' : '0' }">
      <div class="ship-detail"
        :style="{ padding: '20px 20px', backgroundColor: '#ffffff', borderRadius: '10px', marginLeft: isMobileScreen ? '0px' : '20px', marginBottom: isMobileScreen ? '20px' : '0', height: isMobileScreen ? 'calc(80vh - 210px)' : 'calc(108vh - 210px)', width: isMobileScreen ? '100%' : this.pageStatus == 2 ? 'calc(200vh - 190px)' : '43%' }">
        <div class="my-3 flex flex-wrap justify-between gap-2">
          <span v-if="pageStatus == 1">{{ requestData.shipName }}</span>
          <span v-if="pageStatus == 2 && (this.userInfo.role == 4 || this.userInfo.role == 5)">Create a New
            Request</span>
          <span v-if="pageStatus == 2 && !(this.userInfo.role == 4 || this.userInfo.role == 5)">Create a New Ship</span>

        </div>
        <ShipVettingInformation ref="shipVettingForm" :requestData="requestData"
          @get-list="getShipVettingReqeustDetail" />


        <el-dialog title="Confirm To Submit" :visible.sync="confirmToSubmitDialog"
          :width="isMobileScreen ? '100%' : '500px'">
          <div>
            Once submitted, the request cannot be modified.
          </div>
          <template #footer>
            <div class="dialog-footer gap-x-2">
              <el-button plain type="primary" size="mini" @click="confirmToSubmitDialog = false">Cancel</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(1)">Submit</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog :title="`${previousRecordData[0]?.companyName || ''} History Record`"
          :visible.sync="previousRecordDialog" :width="isMobileScreen ? '100%' : '930px'">
          <div>
            <el-table key="previousRecords" :data="previousRecordData" :header-cell-style="{
              height: '55px',
              background: '#fff',
              'border-bottom': '2px solid #D6D9E1',
            }" :cell-style="getCellStyle" table-layout="auto"
              style="width: 10%; height: calc(40vh - 90px); overflow-y: scroll;">
              <el-table-column align="left" prop="companyName" label="Company" min-width="100"></el-table-column>
              <el-table-column align="left" prop="status" label="Status" min-width="150">
                <template slot-scope="scope">
                  <div>
                    {{ getShipVettingStatus(scope.row.status) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" label="File Name" min-width="300">
                <template slot-scope="scope">
                  <div v-if="scope.row.documents && scope.row.documents.length > 0">
                    <div v-for="(file, index) in scope.row.documents" :key="index"
                      @click="viewFile(scope.row.documents[index])">
                      <h1 style="color: #409EFF;">{{ index + 1 }}. {{ file.originalFileName }}</h1>
                    </div>
                  </div>
                  <div v-else>
                    No Files
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="createBy" label="Create By" min-width="130"></el-table-column>
              <el-table-column align="left" prop="createTime" label="Create Time" min-width="200"></el-table-column>
            </el-table>
          </div>
        </el-dialog>

        <pdf-view title="Ship Document" :pdfUrl="pdfUrl" v-model="showPdfView" />

        <el-dialog title="Confirm To Delete" :visible.sync="confirmToDeleteDialog"
          :width="isMobileScreen ? '100%' : '500px'">
          <div>
            Are you sure you want to delete this request?
          </div>
          <template #footer>
            <div class="dialog-footer gap-x-2">
              <el-button plain type="primary" size="mini" @click="confirmToDeleteDialog = false">Cancel</el-button>
              <el-button type="danger" size="mini" @click="handleDelete()">Delete</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="More Information Required" :visible.sync="logisticsRemarksDialog"
          :width="isMobileScreen ? '100%' : '500px'" @close="resetLogisticsRemarksForm()">
          <div>
            <el-form ref="remarksForm" :rules="rules" :model="logisticsRemarksForm">
              <el-form-item label="Please state the remark:" prop="logisticsRemarks">
                <el-input type="textarea" v-model="logisticsRemarksForm.logisticsRemarks" :autosize="{ minRows: 3 }"
                  clearable size="small" style="width:100%" />
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer gap-x-2">
              <el-button plain type="primary" size="mini" @click="resetLogisticsRemarksForm()">{{ $t("btn.close")
              }}</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(8)">{{ $t("btn.submit")
              }}</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog :title="companyReqRemarkTitle" :visible.sync="companyReqRemarkDialog"
          :width="isMobileScreen ? '100%' : '500px'" @close="resetCompanyReqRemark()">
          <div>
            <el-form label-width="auto" size="mini" label-position="top" ref="companyReqRemarkForm" :rules="rules"
              :model="companyReqRemarks">
              <el-form-item label="Please state the remark:" prop="companyReqRemarks">
                <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="companyReqRemarks" clearable size="small"
                  :style="{ width: '100%' }"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetCompanyReqRemark()">{{ $t("btn.close")
              }}</el-button>
              <el-button type="primary" size="mini" @click="submitCompanyReqRemark()">
                {{ $t("btn.submit") }}
              </el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="Suspend Company Request" :visible.sync="companySuspendDialog"
          :width="isMobileScreen ? '100%' : '500px'" @close="resetCompanySuspend()">
          <div>
            <el-form label-width="auto" size="mini" label-position="left">
              <el-form-item label="Start Date">
                <el-date-picker v-model="companySuspendStart" placeholder="Start Date" type="datetime"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
              </el-form-item>

              <el-form-item label="End Date">
                <el-date-picker v-model="companySuspendEnd" placeholder="End Date" type="datetime"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59"
                  :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
              </el-form-item>
            </el-form>
          </div>

          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetCompanySuspend()">
                {{ $t("btn.close") }}
              </el-button>
              <el-button type="primary" size="mini" @click="submitCompanyReqSuspend()">
                {{ $t("btn.submit") }}
              </el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="Reject Terminal Request" :visible.sync="terminalReqRemarkDialog"
          :width="isMobileScreen ? '100%' : '500px'" @close="resetTerminalReqRemark()">
          <div>
            <el-form label-width="auto" size="mini" label-position="top" ref="terminalReqRemarkForm" :rules="rules"
              :model="terminalReqRemark">
              <el-form-item label="Please state the remark:" prop="terminalReqRemark">
                <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="terminalReqRemark" clearable size="small"
                  :style="{ width: '100%' }"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetTerminalReqRemark()">{{ $t("btn.close")
              }}</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(5)">{{ $t("btn.submit")
              }}</el-button>
            </div>
          </template>
        </el-dialog>

        <el-dialog title="Suspend Ship" :visible.sync="suspendedDialog" :width="isMobileScreen ? '100%' : '500px'"
          @close="resetSuspendedForm()">
          <div>
            <el-form label-width="auto" size="mini" label-position="left" ref="suspendedForm">
              <el-form-item label="Start Date" prop="suspendedStartDate">
                <el-date-picker v-model="suspendedStartDate" placeholder="Start Date" type="datetime"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
              </el-form-item>
              <el-form-item label="End Date" prop="suspendedEndDate">
                <el-date-picker v-model="suspendedEndDate" placeholder="End Date" type="datetime"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59"
                  :style="{ width: isMobileScreen ? '100%' : '300px' }" clearable />
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button plain type="primary" size="mini" @click="resetSuspendedForm()">{{ $t("btn.close")
              }}</el-button>
              <el-button type="primary" size="mini" @click="handleStatusButtonClick(10)">{{ $t("btn.submit")
              }}</el-button>
            </div>
          </template>
        </el-dialog>
        <el-dialog title="Upload OCR Document (Q88)" :visible.sync="ocrDialogVisible"
          :width="isMobileScreen ? '100%' : '400px'" @close="resetOcrDialog" style="justify-items: center;">
          <el-upload ref="ocrUploader" class="ocr-upload" drag :auto-upload="false" :file-list="ocrFileList" :limit="1"
            :on-change="handleOcrFileChange" :on-remove="handleOcrFileRemove" :on-exceed="handleOcrExceed"
            :on-preview="handleOcrPreview" accept=".pdf,.doc,.docx" style="width: 100%; justify-items: center;">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" style="width: 100%; justify-items: center;">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              Supported: PDF/DOC/DOCX
            </div>
          </el-upload>

          <template #footer>
            <div class="dialog-footer">
              <el-button plain size="mini" @click="ocrDialogVisible = false">Cancel</el-button>
              <el-button type="primary" size="mini" :loading="ocrUploading" @click="submitOcr">
                OCR & Fill Form
              </el-button>
            </div>
          </template>
        </el-dialog>
      </div>
      <div>
      </div>
      <div class="flex flex-col" v-if="showRightBar" :style="{ width: isMobileScreen ? '100%' : '56%' }">
        <div v-if="showCompanyReq"
          style="padding:20px 20px; background-color:#ffffff; border-radius: 10px; margin-bottom:20px ;"
          :style="{ marginLeft: isMobileScreen ? '0px' : '20px', height: isMobileScreen ? 'calc(74vh - 190px)' : 'calc(72vh - 190px)' }">
          <div class="flex flex-row">
            <h3 class="text-base font-medium">Company Request</h3>
            <div class="ml-4 items-center text-center self-center justify-center"
              style="border-radius: 18px; color: white; background-color: #FF5F5F; width:20px; height: 20px; font-size: 13px;">
              {{ listData.length }}</div>
          </div>
          <div class="divider-line" style="flex-grow: 1; margin-right: 10px;"></div>
          <div style="height: calc(62vh - 170px); overflow-y: auto; padding-right: 8px;">
            <div v-for="value in listData" :key="value.id" class="company-req-card"
              style="box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.19); border: 1px solid #e5e7ed; border-radius: 10px; margin-top: 10px; margin-bottom: 24px;"
              :style="{ padding: isMobileScreen ? '8px' : '16px' }">
              <div class="flex justify-between items-center mb-2">
                <div class="flex flex-row items-center gap-x-2">
                  <p :style="{ fontSize: isMobileScreen ? '10px' : '14px' }">{{ value.companyName }}</p>
                  <el-button class="company-action-btn" size="mini" style="color:#409EFF;border-color:#409EFF;"
                    @click.stop="handlePassRecordClick(value.id)">
                    <span><el-icon class="el-icon-time"></el-icon></span> Past Record
                  </el-button>
                </div>

                <p :style="getCompanyStatusStyle(value.status)">{{ getStatusText(value)
                }}</p>
              </div>
              <div class="divider-line" style="flex-grow: 1; margin-right: 10px;"></div>
              <div class="flex flex-col">
                <div class="flex" :class="{ 'flex-col': isMobileScreen, 'flex-row': !isMobileScreen }">
                  <div class="pr-1 mr-2" :class="{ 'w-full': isMobileScreen, 'w-1/2': !isMobileScreen }">
                    <h3 class="my-2" :style="{ fontSize: isMobileScreen ? '10px' : '12px' }">DOCUMENTS:</h3>
                    <div v-if="value.documents && value.documents.length > 0"
                      style="overflow-y: scroll; max-height: 130px; padding-right: 10px;">
                      <div v-for="(file, index) in value.documents" :key="index"
                        class="flex justify-between items-center flex-row gap-x-2 px-4 py-1 mb-2"
                        style="background-color: #EDF7FF; border-radius: 10px;">
                        <el-tooltip :content="file.originalFileName" placement="top" effect="dark">
                          <span class="doc-filename" @click="viewFile(value.documents[index])">
                            {{ file.originalFileName }}
                          </span>
                        </el-tooltip>
                        <el-button circle size="mini" type="primary" icon="el-icon-document-copy" class="copy-btn"
                          @click="$refs.shipVettingForm.handleFileDuplicated(file)"></el-button>
                      </div>
                    </div>
                    <div v-else class="flex justify-between items-start flex-row gap-x-2 px-4 py-2 my-2"
                      style="background-color: #EDF7FF; border-radius: 10px; color: #409EFF; height: 124px; font-size: 10px; padding-top: 10px;">
                      No Files
                    </div>
                  </div>
                  <div class="pr-4" :class="{ 'w-full': isMobileScreen, 'w-1/2': !isMobileScreen }">
                    <h3 class="my-2" :style="{ fontSize: isMobileScreen ? '10px' : '12px' }">CUSTOMER REMARKS:</h3>
                    <p class="customer-remarks px-4 mb-2 text-sm" style="overflow-y: scroll;">
                      {{ value.customerRemarks || "No Remarks" }}</p>
                  </div>
                </div>
              </div>

              <div class="divider-line" style="flex-grow: 1; margin-right: 10px;"></div>
              <div class="mt-3 pb-3 flex gap-x-1 gap-y-3 " style="overflow-x:scroll">
                <template v-if="getCompanyActionFlags(value.status).showActions">
                  <el-button class="company-action-btn" size="mini" type="success" plain
                    v-if="getCompanyActionFlags(value.status).accept" @click.stop="submitCompanyReqStatus(value.id, 6)">
                    Accept
                  </el-button>

                  <el-button class="company-action-btn" size="mini" type="danger" plain
                    v-if="getCompanyActionFlags(value.status).reject"
                    @click.stop="openCompanyReqRemark(value.id, 5, 'Reject Company Request')">
                    Reject
                  </el-button>
                  <el-button class="company-action-btn" size="mini" type="primary" plain
                    v-if="getCompanyActionFlags(value.status).submitForInspection"
                    @click.stop="submitCompanyReqStatus(value.id, 1)">
                    Submit for Inspection
                  </el-button>

                  <el-button class="company-action-btn" size="mini" type="primary" plain
                    v-if="getCompanyActionFlags(value.status).pendingLogistics"
                    @click.stop="submitCompanyReqStatus(value.id, 1)">
                    Pending Logistics
                  </el-button>

                  <el-button class="company-action-btn" size="mini" type="primary" plain
                    v-if="getCompanyActionFlags(value.status).pendingObservation"
                    @click.stop="openCompanyPendingObsDialog(value)">
                    Pending Observation
                  </el-button>

                  <el-button class="company-action-btn" size="mini" type="primary" plain
                    v-if="getCompanyActionFlags(value.status).anchorageInspection"
                    @click.stop="submitCompanyReqStatus(value.id, 4)">
                    Anchorage Inspection
                  </el-button>

                  <el-button class="company-action-btn" size="mini" type="primary" plain
                    v-if="getCompanyActionFlags(value.status).moreInfoRequired"
                    @click.stop="openCompanyReqRemark(value.id, 8, 'More Information Required')">
                    More Information Required
                  </el-button>

                  <el-button class="company-action-btn" size="mini" type="primary" plain
                    v-if="getCompanyActionFlags(value.status).suspend" @click.stop="openCompanyReqSuspend(value.id)">
                    Suspend
                  </el-button>
                </template>
              </div>
            </div>
          </div>

        </div>
        <div v-if="pageStatus == 1"
          :style="{ padding: '20px 20px', backgroundColor: '#ffffff', borderRadius: '10px', marginLeft: isMobileScreen ? '0px' : '20px', height: contentHeight() }">
          <h3 class="text-lg font-medium ">Timeline</h3>
          <div class="divider-line" style="flex-grow: 1; margin-right: 10px;"></div>
          <ShipVettingTimeline :key="rid" :rid="rid" :requestData="this.requestData"></ShipVettingTimeline>
        </div>
      </div>
    </div>
    <el-dialog title="Pending Observation" :visible.sync="companyPendingObsDialog"
      :width="isMobileScreen ? '100%' : '1100px'" @close="resetCompanyPendingObs" top="5vh" style="overflow-x:visible;"
      custom-class="pending-obs-dialog">
      <div class="pending-obs-body pending-obs-layout" v-loading="companyPendingObsLoading">
        <div class="pending-obs-left">

          <div class="justify-between items-center mb-4 flex">
            <div class="pending-obs-label">Documents</div>

            <el-button class="pending-obs-upload-btn" size="mini" type="primary"
              @click="emailUploadDialogVisible = true">
              Upload PDF
            </el-button>
          </div>


          <div class="pending-doc-list" @scroll="handleOtherDocsScroll">
            <div v-for="item in combinedDocOptions" :key="item.optionValue || item.value">
              <div v-if="item.isGroup" class="dropdown-group-title">
                {{ item.label }}
              </div>

              <div v-else class="pending-doc-item"
                :class="{ active: selectedPreviewDoc && selectedPreviewDoc.optionValue === item.optionValue }"
                @click="handlePendingDocClick(item)">
                <div class="pending-doc-item-top">
                  <el-checkbox :value="isPendingDocSelected(item)" @change="togglePendingDoc(item, $event)"
                    @click.native.stop />
                  <span class="pending-doc-name">{{ item.optionLabel }}</span>
                </div>
              </div>
            </div>

            <div v-if="otherDocsLoadingMore" class="pending-doc-loading">
              <i class="el-icon-loading"></i>
            </div>

            <div v-if="otherDocsFinished" class="pending-doc-loading">
              No more documents
            </div>
          </div>
        </div>

        <div class="pending-obs-right">
          <div class="pending-obs-label">Preview</div>

          <div v-if="selectedPreviewDoc && previewPdfUrl" class="pending-preview-wrap">
            <iframe :src="previewPdfUrl" class="pending-preview-frame" frameborder="0"></iframe>
          </div>

          <div v-else class="pending-preview-empty">
            Select a PDF document to preview
          </div>
        </div>
      </div>
      <template #footer>
        <el-button size="mini" @click="resetCompanyPendingObs">Cancel</el-button>
        <el-button size="mini" type="primary" :disabled="!canSubmitCompanyPendingObs"
          @click="submitCompanyPendingObservation">
          Submit
        </el-button>
      </template>
    </el-dialog>

    <el-dialog title="Upload Document" :visible.sync="emailUploadDialogVisible"
      :width="isMobileScreen ? '100%' : '420px'" @close="resetEmailUploadDialog">
      <el-upload ref="emailDocUploader" class="ocr-upload" drag :auto-upload="false" :file-list="emailUploadFileList"
        :limit="1"
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        :on-change="handleEmailUploadFileChange" :on-remove="handleEmailUploadFileRemove"
        :on-exceed="handleEmailUploadFileExceed" :show-file-list="true">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Drop PDF here or <em>click to upload</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          PDF / DOC / DOCX only
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import tabs from "@/components/tabs.vue";
import { getShipVettingRequestData, deleteShipVettingRequest, modifyLogisticsRequest, getCustomerVettingInfo, getCreateDateList, getCompanyListByImo, getCustomerVettingRecord, updateCustomerVettingStatus, deleteCustomerVetting, uploadFileAPI, ocrShipVettingData, getInspectorDocumentList, } from "@/services";
import PdfView from "@/components/common/pdf-view.vue";
import { mapState } from "vuex";
import ShipVettingHistory from "./history.vue";
import ShipVettingInformation from "./information.vue"
import { getShipVettingStatus } from "@/utils/constants";
import ShipVettingTimeline from './timeline.vue';
import { getServerUrl } from "@/utils/getServerUrl";
import { getUploadImoDocument, uploadEmailDoc } from "@/services/form";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "ShipVettingDetail",
  components: { tabs, PdfView, ShipVettingInformation, ShipVettingHistory, ShipVettingTimeline, vSelect },

  data() {
    return {
      activeTab: "informationTab",
      // activeTab: "historyTab",
      historyKey: 0,
      id: "",
      pageStatus: "", // page mode
      requestStatus: 0,
      // upIndex: 0,
      imo: "",
      shipName: "",
      requestData: {},
      confirmToSubmitDialog: false,
      confirmToDeleteDialog: false,
      // subbtns: false,
      showBtn: true,
      showStatus: "",
      submitToTerminalBtn: false,
      resubmitChangesBtn: false,
      acceptBtn: false,
      rejectBtn: false,
      submitToInspectionBtn: false,
      anchorageInspectionBtn: false,
      moreInfoRequiredBtn: false,
      suspendedBtn: false,
      submitBtn: false,
      deleteBtn: false,
      suspendedDialog: false,
      suspendedStartDate: null,
      suspendedEndDate: null,
      saveBtn: false,
      showCompanyReq: false,
      listData: [],
      vettingRequestDates: [
      ],
      vettingRequestDate: "",
      rid: "",
      previousRecordDialog: false,
      previousRecordData: [],
      showPdfView: false,
      pdfUrl: "",
      vettingReqList: [],
      showRightBar: false,
      companyReqRemarkDialog: false,
      companyReqRemarks: "",
      terminalReqRemarkDialog: false,
      terminalReqRemark: "",
      rejectedId: 0,
      pendingObsBtn: false,
      baseUrl: getServerUrl(),
      logisticsRemarksDialog: false,
      logisticsRemarksForm: {
        logisticsRemarks: ""
      },
      ocrBtn: false,
      ocrDialogVisible: false,
      ocrUploading: false,
      ocrFileList: [],
      rules: {
        logisticsRemarks: [{ required: true, message: " ", trigger: "blur" }],
        companyReqRemarks: [
          { required: true, message: " ", trigger: "blur" },
        ],
        terminalReqRemark: [
          { required: true, message: " ", trigger: "blur" },
        ],
      },
      companyReqRemarkTitle: "Reject Company Request",
      companyReqTargetId: null,
      companyReqTargetStatus: null,
      companySuspendDialog: false,
      companySuspendTargetId: null,
      companySuspendStart: null,
      companySuspendEnd: null,
      companyPendingObsDialog: false,
      companyPendingObsLoading: false,
      companyPendingObsTargetId: null,
      combinedDocOptions: [],
      selectedPendingDocs: [],
      inspectorDocParams: {
        pageNum: 1,
        pageSize: 20,
        uploadTime: [],
      },
      otherDocsLoadingMore: false,
      otherDocsFinished: false,
      otherInspectorDocs: [],
      recentUploadDocs: [],
      emailUploadDialogVisible: false,
      emailUploadFileList: [],
      emailUploading: false,
      selectedPreviewDoc: null,
      previewPdfUrl: "",
    };
  },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    visibleCompanyReqList() {
      return (this.listData || []).slice(0, 3);
    },

    shipDocumentDisabled() {
      const pageStatus = this.$route.query.pageStatus;
      const isLogistics = this.userInfo.role == 1;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;

      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      if (pageStatus == 2) {
        return false;
      }
      if (Number(this.requestData.id) !== Number(this.$route.query.id)) {
        return true;
      }
      if (isLogistics && (requestStatus == 1 || requestStatus == 3 || requestStatus == 9 || requestStatus == 4)) {
        return false;
      }
      if ((isCustomer || isLogistics) && (requestStatus == 1 || requestStatus == 7 || requestStatus == 8)) {
        return false;
      }
      return true;
    },

    canSaveInfo() {
      const pageStatus = Number(this.$route.query.pageStatus ?? 0);
      if (pageStatus !== 1) return false;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;
      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      if (requestStatus == 10) return false;

      const role = this.userInfo?.role;
      const isLogistics = role == 1 || role == "1";
      return isLogistics;
    },

    canUseOcr() {
      const pageStatus = Number(this.$route.query.pageStatus ?? 0);
      const role = Number(this.userInfo.role);

      const isLogistics = role === 1;
      const isCustomer = role === 4 || role === 5;

      return (
        (isLogistics && (pageStatus === 1 || pageStatus === 2)) ||
        (isCustomer && pageStatus === 2)
      );
    },

    canSubmitCompanyPendingObs() {
      return this.selectedPendingDocs.length > 0;
    },
  },
  created() {
    this.getShipVettingReqeustDetail();
  },
  watch: {
    vettingRequestDate(newVal) {
      const selectedItem = this.vettingReqList.find((item) => item.createTime === newVal);

      if (selectedItem) {
        this.selectedItemId = selectedItem.id;
        getCustomerVettingInfo(selectedItem.id).then((res) => {
          if (res.code === 200) {
            this.requestData = res.data;
            this.imo = res.data.imo;
            this.historyKey += 1;
            this.rid = res.data.id;
            this.showButtons();
          }
        });
      }
    },
  },
  mounted() {
    const { id, pageStatus } = this.$route.query;
    this.id = id;
    this.pageStatus = pageStatus;
    // this.getShipVettingReqeustDetail();
  },
  methods: {
    getShipVettingStatus,
    showCompanyReqAccept(status) {
      if (this.requestData.shipStatus == 6) {
        if (status == 6) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    showCompanyReqReject(status) {
      if (status == 5) {
        return false;
      } else {
        return true;
      }
    },
    getShipVettingReqeustDetail() {
      this.logisticsRemarks = "";
      if (this.$route.query.pageStatus == 2) {
        this.showButtons();
        return;
      }
      if (!(this.userInfo.role == 4 || this.userInfo.role == 5)) {
        getShipVettingRequestData(this.$route.query.id).then((res) => {
          if (res.code == 200) {
            this.requestData = res.data
            this.imo = res.data.imo
            this.historyKey += 1;
            this.rid = res.data.id;
            this.showButtons();
          }
          getCompanyListByImo(this.imo).then((res) => {
            if (res.code == 200) {
              this.listData = res.data;
            }
          });
        });
      } else {
        getCreateDateList({ imo: this.$route.query.imo }).then((res) => {
          if (res.code == 200) {
            const data = res.data;
            this.vettingRequestDates = [];
            this.vettingReqList = data;

            data.forEach((item) => {
              this.vettingRequestDates.push(item.createTime);
            });
            const selectedItem = data.find((item) => item.id === this.$route.query.id || item.id === Number(this.$route.query.id)) || data[0];
            this.vettingRequestDate = selectedItem.createTime;

            getCustomerVettingInfo(selectedItem.id).then((res) => {
              if (res.code == 200) {
                this.requestData = res.data;
                this.imo = res.data.imo;
                this.historyKey += 1;
                this.rid = res.data.id;
                this.showButtons();
              }
            });
          }
        });
      }
    },

    contentHeight() {
      if (this.showRightBar) {
        if (this.showCompanyReq) {
          return this.isMobileScreen ? "calc(68vh - 178px)" : "calc(52vh - 178px)"
        }
        return "calc(108vh - 210px)";
      }
    },

    getCompanyStatusStyle(status) {
      const statusColors = {
        5: { color: "red", fontSize: "8px", backgroundColor: '#FFB8B8', padding: '4px 8px', borderRadius: '12px' },
        6: { color: "green", fontSize: "8px", backgroundColor: '#B8FFB8', padding: '4px 8px', borderRadius: '12px' },
      };
      return statusColors[status] || { color: "#F37E01", fontSize: "8px", backgroundColor: '#FFDCB8', padding: '4px 8px', borderRadius: '12px' };
    },

    getStatusColor(status) {
      switch (status) {
        case 5:
        case 9:
        case 10:
          return "red";
        case 6:
          return "green";
        default:
          return "#57a2de";
      }
    },

    getCellStyle({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return {
          backgroundColor: "rgba(255,255,255,0.2)",
        };
      } else {
        return {
          backgroundColor: "rgba(228,228,228,0.2)",
        };
      }
    },
    viewFile(file) {
      if (file.documentUrl) {
        this.pdfUrl = process.env.VUE_APP_BASE_API + file.documentUrl,
          this.showPdfView = true;
      } else {
        this.$message.warning('Unable to view the file');
      }
    },
    showButtons(val) {
      const pageStatus = this.$route.query.pageStatus;
      const isLogistics = this.userInfo.role == 1;
      const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;
      const isInspector = this.userInfo.role == 13;
      const requestStatus = isCustomer ? this.requestData.status : this.requestData.shipStatus;
      const routePageStatus = Number(this.$route.query.pageStatus ?? 0);
      const isLogisticView = this.userInfo.role == 16

      // show OCR on Create page (pageStatus=2) for customer + logistics (adjust if you want only customer)
      this.ocrBtn = routePageStatus === 2 && (isCustomer || isLogistics);

      // create new request
      if (pageStatus == 2) {
        if (isLogistics) {
          this.acceptBtn = true;
          this.rejectBtn = true;
          this.submitToInspectionBtn = true;
          this.anchorageInspectionBtn = true;
          this.moreInfoRequiredBtn = true;
          this.suspendedBtn = true;
        }
        if (isCustomer) {
          this.submitToTerminalBtn = true;
        }
        return;
      }

      if (isLogisticView) {
        this.showRightBar = true;
        this.showCompanyReq = true;
      }

      // modify request
      if (isLogistics) {
        this.showRightBar = true;
        this.showCompanyReq = true;
        if (requestStatus == 1 || requestStatus == 3 || requestStatus == 6 || requestStatus == 5 || requestStatus == 9) {
          this.showBtn = true;
          this.pendingObsBtn = requestStatus == 6;
          this.acceptBtn = true;
          this.rejectBtn = true;
          this.anchorageInspectionBtn = true;
          this.moreInfoRequiredBtn = true;
          this.suspendedBtn = true;
          if (requestStatus == 1 || requestStatus == 9) {
            this.submitToInspectionBtn = true;
          }
          if (requestStatus == 6) {
            this.acceptBtn = false;
            this.submitToInspectionBtn = true;
          }
          if (requestStatus == 5) {
            this.rejectBtn = false;
            this.submitToInspectionBtn = true;
          }
        } else {
          if (requestStatus == 4) {
            this.saveBtn = false;
            this.pendingObsBtn = true;
            this.submitToInspectionBtn = true;
          } else {
            this.saveBtn = true;
            this.pendingObsBtn = false;
            this.submitToInspectionBtn = false;
          }
          this.handleShowStatus();
        }
      }
      if (isCustomer) {
        this.showRightBar = true;
        if (Number(this.selectedItemId) !== Number(this.$route.query.id)) {
          this.showBtn = false;
          this.disableForm = true;
        } else if (requestStatus == 1) {
          this.showBtn = true;
          this.resubmitChangesBtn = true;
          this.submitBtn = false;
          this.deleteBtn = true;
        } else if (requestStatus == 7 || requestStatus == 8) {
          this.showBtn = true;
          this.resubmitChangesBtn = false;
          this.submitBtn = true;
          this.deleteBtn = false;
        } else {
          this.handleShowStatus();
        }
      }
      if (isInspector) {
        this.saveBtn = false;
        this.showRightBar = true;
        if ((requestStatus == 2 || requestStatus == 4)) {
          this.submitBtn = true;
        } else {
          this.pendingObsBtn = requestStatus == 6;
          this.handleShowStatus();
        }
      }
      this.ocrBtn = (this.pageStatus == 2) && (
        this.userInfo.role == 1 || this.userInfo.role == 4 || this.userInfo.role == 5
      );
    },
    handleShowStatus() {
      this.showBtn = false;
      this.showStatus = getShipVettingStatus(this.requestData.shipStatus);

      if (this.requestData.status === 10) {
        const sus = this.showStatus;
        const susStart = this.requestData.suspendedStart;
        const susEnd = this.requestData.suspendedEnd;
        if (!susStart && !susEnd) {
          return;
        }
        this.showStatus = sus + this.isMobileScreen ? '\n' : "" + " from " + susStart + " to " + susEnd;
      }
    },
    async fetchDoc(doc) {
      const docUrl = doc.documentUrl.startsWith('https')
        ? doc.documentUrl
        : this.baseUrl + doc.documentUrl;
      const response = await fetch(docUrl, { method: "GET" });
      const blob = await response.blob();

      return new File([blob], doc.originalFileName, { type: blob.type });
    },
    handleCloseClick() {
      this.pageStatus = 0;
      if (this.$route.query.pageStatus == 2) {
        this.requestData = {};
      }
      // this.$router.back();
      this.$router.push({ path: "/ship-vetting/index" });
      // fix back error
      setTimeout(() => {
        if (this.$route.path == "/ship-vetting/index" && this.$route.query.id) {
          this.$router.push({ path: "/ship-vetting/index" });
        }
      }, 500);
    },
    handleStatusButtonClick(status) {
      // Suspended
      if (status == 10) {
        if ((this.suspendedStartDate == null || this.suspendedEndDate == null)) {
          this.$message.error("Start Date and End Date required");
          return;
        }
        if (new Date(this.suspendedEndDate) < new Date(this.suspendedStartDate)) {
          this.$message.error("End Date must be after Start Date");
          return;
        }
      }

      if (status === 8 && (!this.logisticsRemarksForm.logisticsRemarks || !this.logisticsRemarksForm.logisticsRemarks.trim())) {
        this.$refs.remarksForm?.validate();
        this.$message.error("Remark required");
        return;
      }

      const params = {
        status: status,
        logisticsRemarks: this.logisticsRemarksForm.logisticsRemarks,
        suspendedStartDate: this.suspendedStartDate,
        suspendedEndDate: this.suspendedEndDate,
      }


      if (status == 5 && this.terminalReqRemarkDialog == true) {
        this.$refs["terminalReqRemarkForm"].validate();
        if (this.terminalReqRemark == null || this.terminalReqRemark.trim() == "") {
          this.$message.error("Remark cannot be empty");
          return;
        }
        delete params.logisticsRemarks;
        delete params.suspendedStartDate;
        delete params.suspendedEndDate;
        params.rejectRemarks = this.terminalReqRemark;
      }


      this.$refs.shipVettingForm.updateRequest(params, () => {
        this.confirmToSubmitDialog = false;
        this.resetTerminalReqRemark();
        this.resetLogisticsRemarksForm();
        this.resetSuspendedForm();
        this.getShipVettingReqeustDetail();
      });


    },
    handleDelete() {
      if (this.requestData.status != 1) {
        this.$message.error("Request status has been changed. Not allowed to delete.");
        return;
      }
      if (this.userInfo.role == 4 || this.userInfo.role == 5) {
        deleteCustomerVetting(this.$route.query.id).then((res) => {
          if (res.code == 200) {
            this.$message.success("Request deleted");
            this.handleCloseClick();
          } else {
            this.$message.error("Failed to delete request");
          }
        });
      } else {
        deleteShipVettingRequest(this.$route.query.id).then((res) => {
          if (res.code == 200) {
            this.$message.success("Request deleted");
            this.handleCloseClick();
          }
        });
      }
    },
    getShipVetStatus() {
      const stat = getShipVettingStatus(this.requestData.shipStatus || this.requestData.status);
      if (this.requestData.shipStatus == 10 || this.requestData.status == 10) {
        const sus = stat;
        const susStart = this.requestData.suspendedStart;
        const susEnd = this.requestData.suspendedEnd;
        if (!susStart && !susEnd) {
          return stat;
        }
        return sus + " from " + susStart + " to " + susEnd;
      }
      return stat;
    },
    handleRejectCompanyReq(id) {
      this.rejectedId = id;
      this.companyReqRemarkDialog = true;
    },
    resetLogisticsRemarksForm() {
      this.logisticsRemarksDialog = false;
      this.logisticsRemarksForm.logisticsRemarks = "";
      this.$nextTick(() => this.$refs.remarksForm?.clearValidate());
    },

    resetSuspendedForm() {
      this.suspendedDialog = false;
      this.suspendedStartDate = null;
      this.suspendedEndDate = null;
    },
    resetCompanyReqRemark() {
      // this.$refs["companyReqRemarkForm"].clearValidate();
      this.companyReqRemarkDialog = false;
      this.companyReqRemarks = "";
    },
    resetTerminalReqRemark() {
      // this.$refs["terminalReqRemarkForm"].clearValidate();
      this.terminalReqRemarkDialog = false;
      this.terminalReqRemark = "";
    },
    formatCompleteTime(row, column, cellValue) {
      if (!cellValue) return '';
      return cellValue.replace('T', ' ');
    },
    async handleSaveClick() {
      // pass the current status back into the child so it can
      // both update the data and upload/delete files
      await this.$refs.shipVettingForm.updateRequest({
        status: this.requestData.status,
        skipStatusUpdate: true
      });
    },
    async handleSaveClickTerminal() {
      // Save "terminal info" only (no status change, no file upload) - API: /shipVetting/updateRequestInfo/{id}
      if (this.$refs.shipVettingForm?.saveRequestInfoOnly) {
        await this.$refs.shipVettingForm.saveRequestInfoOnly();
      }
    },
    handlePassRecordClick(imo) {
      this.previousRecordDialog = true;
      getCustomerVettingRecord(imo).then((res) => {
        if (res.code == 200) {
          this.previousRecordData = res.data;
        } else {
          this.$message.error("Failed to fetch previous records");
        }
      });
    },
    handleCompanyReq(id, status) {
      if (this.companyReqRemarkDialog == true) {
        this.$refs["companyReqRemarkForm"].validate();
        if (this.companyReqRemarks == null || this.companyReqRemarks.trim() == "") {
          this.$message.error("Remark cannot be empty");
          return;
        }
      }
      const reqBody = {
        id: id,
        status: status,
        terminal_remarks: this.companyReqRemarks ?? undefined,
      };
      updateCustomerVettingStatus(reqBody).then((res) => {
        if (res.code == 200) {
          this.$message.success("Request updated successfully");
          this.getShipVettingReqeustDetail();
          this.resetCompanyReqRemark();
        } else {
          this.$message.error("Failed to update request");
        }
      });
    },
    openOcrDialog() {
      this.ocrDialogVisible = true;
    },

    handleOcrFileChange(file, fileList) {
      const raw = file?.raw;
      const name = (raw?.name || file?.name || "").toLowerCase();

      const allowed = name.endsWith(".pdf") || name.endsWith(".doc") || name.endsWith(".docx");

      if (!allowed) {
        this.$message.error("Only PDF / DOC / DOCX are allowed");
        this.$refs.ocrUploader?.clearFiles();
        this.ocrFileList = [];
        return;
      }

      this.ocrFileList = (fileList || []).slice(-1);
    },

    handleOcrExceed(files) {
      const raw = files[0];
      this.$refs.ocrUploader.clearFiles();
      this.$refs.ocrUploader.handleStart(raw);

      this.$nextTick(() => {
        this.ocrFileList = (this.$refs.ocrUploader.uploadFiles || []).slice(-1);
      });
    },

    handleOcrFileRemove() {
      this.ocrFileList = [];
    },

    resetOcrDialog() {
      this.ocrUploading = false;
      this.ocrFileList = [];
      if (this.$refs.ocrUploader) this.$refs.ocrUploader.clearFiles();
    },

    async submitOcr() {
      const list = this.$refs.ocrUploader?.uploadFiles?.length
        ? this.$refs.ocrUploader.uploadFiles
        : this.ocrFileList;

      if (!list || list.length === 0) {
        this.$message.error("Please upload a file first");
        return;
      }

      const rawFile = list[0]?.raw || list[0];
      if (!rawFile) {
        this.$message.error("Invalid file");
        return;
      }

      const fd = new FormData();
      fd.append("file", rawFile);

      this.ocrUploading = true;
      try {
        const res = await ocrShipVettingData(fd);
        const payload = res?.data ?? res;

        const isCreatePage = Number(this.$route.query.pageStatus) === 2;
        const isCustomer = this.userInfo.role == 4 || this.userInfo.role == 5;

        // customer create page: uploading another OCR file resets form first
        if (isCreatePage && isCustomer) {
          this.$refs.shipVettingForm?.resetFormForNewOcr?.();
        }

        if (this.$refs.shipVettingForm?.applyOcrData) {
          this.$refs.shipVettingForm.applyOcrData(payload);
        } else {
          this.$message.warning("Form reference not found (shipVettingForm)");
        }

        if (this.$refs.shipVettingForm?.addOcrFileToShipDocuments) {
          this.$refs.shipVettingForm.addOcrFileToShipDocuments(rawFile);
        }

        setTimeout(() => {
          this.$message.success("OCR result applied and file added to Ship Document");
        }, 100);

        this.ocrDialogVisible = false;
        this.resetOcrDialog();
      } catch (e) {
        this.$message.error("OCR failed");
        console.error(e);
      } finally {
        this.ocrUploading = false;
      }
    },
    handleOcrPreview(file) {
      const raw = file?.raw;
      if (!raw) {
        this.$message.warning("No file to preview");
        return;
      }

      const name = (raw.name || "").toLowerCase();

      if (name.endsWith(".pdf")) {
        const url = URL.createObjectURL(raw);

        this.pdfUrl = url;
        this.showPdfView = true;
        return;
      }

      if (name.endsWith(".doc") || name.endsWith(".docx")) {
        this.$message.warning(
          "DOC/DOCX files cannot be previewed. Please download and open locally."
        );
        return;
      }

      this.$message.error("Unsupported file type");
    },
    howCompanyAction(currentStatus, targetStatus) {
      if (Number(currentStatus) === Number(targetStatus)) return false;

      return true;
    },

    submitCompanyReqStatus(id, status) {
      const reqBody = { id, status };

      updateCustomerVettingStatus(reqBody).then((res) => {
        if (res.code === 200) {
          this.$message.success("Company request updated");
          this.getShipVettingReqeustDetail();
        } else {
          this.$message.error("Failed to update company request");
        }
      });
    },

    openCompanyReqRemark(id, status, title) {
      this.companyReqTargetId = id;
      this.companyReqTargetStatus = status; // 5 reject or 8 more info
      this.companyReqRemarkTitle = title;

      this.companyReqRemarkDialog = true;
      this.companyReqRemarks = "";

      this.$nextTick(() => this.$refs.companyReqRemarkForm?.clearValidate());
    },

    submitCompanyReqRemark() {
      this.$refs["companyReqRemarkForm"]?.validate();

      if (!this.companyReqRemarks || !this.companyReqRemarks.trim()) {
        this.$message.error("Remark cannot be empty");
        return;
      }

      const reqBody = {
        id: this.companyReqTargetId,
        status: this.companyReqTargetStatus, // 5 or 8
        terminal_remarks: this.companyReqRemarks.trim(),
      };

      updateCustomerVettingStatus(reqBody).then((res) => {
        if (res.code === 200) {
          this.$message.success("Company request updated");
          this.getShipVettingReqeustDetail();
          this.resetCompanyReqRemark();
        } else {
          this.$message.error("Failed to update company request");
        }
      });
    },

    openCompanyReqSuspend(id) {
      this.companySuspendTargetId = id;
      this.companySuspendStart = null;
      this.companySuspendEnd = null;
      this.companySuspendDialog = true;
    },

    resetCompanySuspend() {
      this.companySuspendDialog = false;
      this.companySuspendTargetId = null;
      this.companySuspendStart = null;
      this.companySuspendEnd = null;
    },

    submitCompanyReqSuspend() {
      if (!this.companySuspendStart || !this.companySuspendEnd) {
        this.$message.error("Start Date and End Date required");
        return;
      }
      if (new Date(this.companySuspendEnd) < new Date(this.companySuspendStart)) {
        this.$message.error("End Date must be after Start Date");
        return;
      }

      const reqBody = {
        id: this.companySuspendTargetId,
        status: 10,
        suspendedStart: this.companySuspendStart,
        suspendedEnd: this.companySuspendEnd,
      };

      updateCustomerVettingStatus(reqBody).then((res) => {
        if (res.code === 200) {
          this.$message.success("Company request suspended");
          this.getShipVettingReqeustDetail();
          this.resetCompanySuspend();
        } else {
          this.$message.error("Failed to suspend company request");
        }
      });
    },
    getCompanyActionFlags(companyStatus) {
      const s = Number(companyStatus);

      const flags = {
        showActions: false,
        submitForInspection: false,
        pendingObservation: false,
        anchorageInspection: false,
        moreInfoRequired: false,
        accept: false,
        reject: false,
        suspend: false,
        pendingLogistics: false,
      };

      flags.showActions = true;

      if ([1, 3, 4, 6, 7, 9, 10, 5].includes(s)) {
        flags.submitForInspection = true;
        flags.anchorageInspection = true;
        flags.pendingObservation = true;
        flags.moreInfoRequired = true;
        flags.accept = true;
        flags.reject = true;
        flags.suspend = true;
      }

      if (s === 9) {
        flags.pendingObservation = false;
      }

      if (s == 8) {
        flags.pendingLogistics = true;
      }

      if (s === 3) {
        flags.submitForInspection = false;
        flags.pendingObservation = false;
      }

      if (s === 5) {
        flags.reject = false;
        flags.pendingObservation = false
      }

      if (s === 1) {
        flags.pendingObservation = false;
        flags.submitForInspection = false;
      }
      if (s === 6) flags.accept = false;

      if (s === 4) {
        flags.anchorageInspection = false;
        flags.submitForInspection = true;
        flags.pendingObservation = true;
        flags.moreInfoRequired = false;
        flags.accept = false;
        flags.reject = false;
        flags.suspend = false;
      }

      if (s === 10) {
        flags.showActions = false;
      }

      if (s === 7) {
        flags.submitForInspection = false;
        flags.anchorageInspection = false;
        flags.pendingObservation = false;
        flags.moreInfoRequired = false;
        flags.accept = false;
        flags.reject = false;
        flags.suspend = false;
        flags.pendingLogistics = true;
      }
      return flags;
    },

    getStatusText(value) {
      if (value.status === 10) {
        const sus = getShipVettingStatus(value.status);
        const susStart = value.suspendedStart;
        const susEnd = value.suspendedEnd;
        if (!susStart && !susEnd) {
          return;
        }
        return sus + " from " + susStart + " to " + susEnd;
      };
      return getShipVettingStatus(value.status);
    },
    formatDisplayTime(val) {
      if (!val) return "";
      return String(val).replace("T", " ").split(".")[0];
    },

    async openCompanyPendingObsDialog(row) {
      this.companyPendingObsTargetId = row.id;
      this.companyPendingObsDialog = true;
      await this.loadInspectorDocsForCompany();
    },

    async loadInspectorDocsForCompany() {
      this.companyPendingObsLoading = true;

      this.inspectorDocParams.pageNum = 1;
      this.otherDocsFinished = false;
      this.otherInspectorDocs = [];
      this.recentUploadDocs = [];

      try {
        const recentRes = await getUploadImoDocument({ imo: this.requestData.imo });

        this.recentUploadDocs = (recentRes?.data || []).map((item) => ({
          ...item,
          isGroup: false,
          optionType: "extra",
          optionGroup: "Recent upload",
          optionValue: `extra-${item.id}`,
          optionLabel: item.originalFileName,
          optionMeta: `${item.createBy || "-"} · ${this.formatDisplayTime(item.createTime)}`,
        }));

        await this.loadMoreOtherInspectorDocs();

        this.rebuildCombinedDocOptions();

        const firstPreviewable = this.combinedDocOptions.find(
          item =>
            !item.isGroup &&
            item.documentUrl &&
            /\.(pdf|doc|docx)$/i.test(String(item.originalFileName || ""))
        );

        if (firstPreviewable) {
          this.handlePendingDocClick(firstPreviewable);
        } else {
          this.selectedPreviewDoc = null;
          this.previewPdfUrl = "";
        }
      } catch (e) {
        this.$message.error("Failed to load documents");
      } finally {
        this.companyPendingObsLoading = false;
      }
    },

    rebuildCombinedDocOptions() {
      this.combinedDocOptions = [
        { isGroup: true, label: "Recent upload", value: "__group_recent" },
        ...this.recentUploadDocs,
        { isGroup: true, label: "Other inspector documents", value: "__group_other" },
        ...this.otherInspectorDocs,
      ];
    },

    async loadMoreOtherInspectorDocs() {
      if (this.otherDocsLoadingMore || this.otherDocsFinished) return;

      const currentPage = this.inspectorDocParams.pageNum;

      this.otherDocsLoadingMore = true;

      try {
        const req = {
          ...this.inspectorDocParams,
          pageNum: currentPage,
        };

        if (req.uploadTime && req.uploadTime.length === 2) {
          req.uploadTimeStart = req.uploadTime[0];
          req.uploadTimeEnd = req.uploadTime[1];
        }

        delete req.uploadTime;

        console.log("Loading other docs page:", currentPage, req);

        const res = await getInspectorDocumentList({
          ...req,
          searchValue: this.requestData.imo,
        });

        const rows = res?.rows || [];

        const mappedDocs = rows.map((item) => ({
          ...item,
          isGroup: false,
          optionType: "inspector",
          optionGroup: "Other inspector documents",
          optionValue: `inspector-${item.docsId}`,
          optionLabel: item.originalFileName,
          optionMeta: `${item.uploadBy || "-"} · ${item.uploadTime || ""}`,
        }));

        this.otherInspectorDocs.push(...mappedDocs);

        this.inspectorDocParams.pageNum = currentPage + 1;

        if (rows.length < this.inspectorDocParams.pageSize) {
          this.otherDocsFinished = true;
        }

        this.rebuildCombinedDocOptions();
      } catch (e) {
        this.$message.error("Failed to load more documents");
      } finally {
        this.otherDocsLoadingMore = false;
      }
    },

    handleOtherDocsScroll(e) {
      const el = e.target;

      const nearBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 120;

      if (nearBottom) {
        this.loadMoreOtherInspectorDocs();
      }
    },

    resetCompanyPendingObs() {
      this.companyPendingObsDialog = false;
      this.companyPendingObsTargetId = null;
      this.combinedDocOptions = [];
      this.selectedPendingDocs = [];
      this.selectedPreviewDoc = null;
      this.previewPdfUrl = "";
    },

    async submitCompanyPendingObservation() {
      if (!this.selectedPendingDocs.length) {
        this.$message.error("Please select at least one document");
        return;
      }

      try {
        const inspectorDocsId = this.selectedPendingDocs
          .filter((item) => item.optionType === "inspector")
          .map((item) => item.docsId);

        const extraDocsId = this.selectedPendingDocs
          .filter((item) => item.optionType === "extra")
          .map((item) => item.id);

        const reqBody = {
          id: this.companyPendingObsTargetId,
          status: 7,
          inspectorDocsId,
          extraDocsId,
        };

        const res = await updateCustomerVettingStatus(reqBody);

        if (res.code === 200) {
          this.$message.success("Pending Observation email sent");
          this.resetCompanyPendingObs();
          this.getShipVettingReqeustDetail();
        } else {
          this.$message.error(res.msg || "Failed to submit");
        }
      } catch (e) {
        this.$message.error("Failed to submit");
      }
    },

    handleEmailUploadFileChange(file, fileList) {
      const raw = file?.raw;
      const name = (raw?.name || file?.name || "").toLowerCase();

      const isPdf = name.endsWith(".pdf") || raw?.type === "application/pdf";
      const isDoc = name.endsWith(".doc") || raw?.type === "application/msword";
      const isDocx =
        name.endsWith(".docx") ||
        raw?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

      const isAllowed = isPdf || isDoc || isDocx;

      if (!isAllowed) {
        this.$refs.emailDocUploader?.clearFiles();
        this.emailUploadFileList = [];

        this.$alert("Only PDF, DOC, and DOCX files can be uploaded.", "Warning", {
          confirmButtonText: "OK",
          type: "warning",
        });
        return;
      }

      this.emailUploadFileList = [file];

      this.submitEmailUpload(file);
    },

    handleEmailUploadFileRemove() {
      this.emailUploadFileList = [];
    },

    handleEmailUploadFileExceed(files) {
      const raw = files[0];
      this.$refs.emailPdfUploader?.clearFiles();
      this.$refs.emailPdfUploader?.handleStart(raw);

      this.$nextTick(() => {
        this.emailUploadFileList = (this.$refs.emailPdfUploader?.uploadFiles || []).slice(-1);
      });
    },

    resetEmailUploadDialog() {
      this.emailUploading = false;
      this.emailUploadFileList = [];
      this.$refs.emailDocUploader?.clearFiles();
    },

    async submitEmailUpload(file) {
      const rawFile = file?.raw || file;

      if (!rawFile) return;

      const formData = new FormData();
      formData.append("files", rawFile);
      formData.append("imo", this.requestData.imo);

      this.emailUploading = true;

      try {
        const res = await uploadEmailDoc(formData);

        if (res.code === 200) {
          this.$message.success("Document uploaded successfully");

          // close dialog immediately
          this.emailUploadDialogVisible = false;

          this.resetEmailUploadDialog();

          // 🔥 refresh list so new doc appears
          await this.loadInspectorDocsForCompany();
        } else {
          this.$message.error(res.msg || "Upload failed");
        }
      } catch (e) {
        this.$message.error("Upload failed");
      } finally {
        this.emailUploading = false;
      }
    },
    handlePendingDocClick(item) {
      this.selectedPreviewDoc = item;

      const rawUrl = item.documentUrl
        ? `${process.env.VUE_APP_BASE_API}${item.documentUrl}`
        : "";

      if (!rawUrl) {
        this.previewPdfUrl = "";
        return;
      }

      const lowerName = String(item.originalFileName || "").toLowerCase();

      const isPdf = lowerName.endsWith(".pdf");
      const isDoc = lowerName.endsWith(".doc");
      const isDocx = lowerName.endsWith(".docx");

      // 📱 detect mobile
      const isMobile =
        /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

      // ✅ PDF → direct preview
      if (isPdf) {
        this.previewPdfUrl = rawUrl;
        return;
      }

      // ✅ DOC / DOCX
      if (isDoc || isDocx) {
        // 📱 Mobile → Google viewer (better support)
        if (isMobile) {
          this.previewPdfUrl = `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(rawUrl)}`;
        } else {
          // 💻 Desktop → Office viewer
          this.previewPdfUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(rawUrl)}`;
        }
        return;
      }

      this.previewPdfUrl = "";
    },

    isPendingDocSelected(item) {
      return this.selectedPendingDocs.some(
        doc => doc.optionValue === item.optionValue
      );
    },

    togglePendingDoc(item, checked) {
      const exists = this.selectedPendingDocs.some(
        doc => doc.optionValue === item.optionValue
      );

      if (checked && !exists) {
        this.selectedPendingDocs.push(item);
      }

      if (!checked && exists) {
        this.selectedPendingDocs = this.selectedPendingDocs.filter(
          doc => doc.optionValue !== item.optionValue
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ship-detail {
  overflow-y: scroll;
}

.divider-line {
  padding-bottom: 5px;
  border-bottom: 2px solid #e5e7ed;
}

.ocr-upload .el-upload-dragger {
  display: flex;
  flex-direction: column;
}

.ocr-upload .el-upload-dragger {
  height: 180px;
}

.ocr-upload .el-icon-upload {
  margin-bottom: 8px;
}

.ocr-upload .el-upload__text {
  line-height: 1.4;
}

::v-deep .el-button.company-action-btn {
  margin-left: 0 !important;
  font-size: 8.5px;
}

::v-deep .company-action-btn {
  padding: 4px 8px !important;
  min-height: 28px;
  line-height: 20px;
  border-radius: 6px;
}

::v-deep .company-action-btn .el-button__inner {
  padding: 0;
}

.company-req-scroll {
  max-height: 520px;
  /* adjust to fit your right panel */
  overflow-y: auto;
}

.company-req-card {
  box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.19);
  border: 1px solid #e5e7ed;
  margin-top: 12px;
  padding: 16px;
  border-radius: 10px;
}

::v-deep .copy-btn {
  width: 28px;
  height: 28px;
}

.customer-remarks {
  background-color: #EDF7FF;
  border-radius: 10px;
  color: #409EFF;
  font-size: 10px;
  padding-bottom: 8px;
  padding-top: 8px;
  width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  height: 124px;
}

.doc-filename {
  color: #409EFF;
  font-size: 10px;
  max-width: 180px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.pending-obs-body {
  height: 100%;
}

/* Layout */
.pending-obs-layout {
  display: flex;
  gap: 16px;
  height: 70vh;
}

/* Left panel (list) */
.pending-obs-left {
  width: 40%;
  border-right: 1px solid #ebeef5;
  padding-right: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Right panel (preview) */
.pending-obs-right {
  width: 60%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Section label */
.pending-obs-label {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

/* Scrollable list */
.pending-doc-list {
  overflow-y: scroll;
  flex: 1;
  padding-right: 4px;
}

/* Group title (Recent / Other) */
.dropdown-group-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  padding: 10px 12px 6px;
  background: #fff;
}

/* Each doc item */
.pending-doc-item {
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  background: #fff;
  transition: all 0.2s;
}

.pending-doc-item:hover {
  border-color: #409eff;
  background: #f5faff;
}

.pending-doc-item.active {
  border-color: #409eff;
  background: #edf7ff;
}

/* Checkbox + name */
.pending-doc-item-top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pending-doc-name {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  word-break: break-word;
}

/* Meta text */
.pending-doc-meta {
  font-size: 11px;
  color: #909399;
  margin-top: 6px;
  padding-left: 22px;
}

/* Preview container */
.pending-preview-wrap {
  flex: 1;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  overflow: hidden;
  background: #f9fafc;
}

/* PDF iframe */
.pending-preview-frame {
  width: 100%;
  height: 100%;
  min-height: 520px;
}

/* Empty preview */
.pending-preview-empty {
  flex: 1;
  border: 1px dashed #dcdfe6;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  min-height: 520px;
  font-size: 13px;
}

/* Upload button spacing */
.pending-obs-upload-btn {
  margin-bottom: 10px;
}

/* Scrollbar (optional nicer UI) */
.pending-doc-list::-webkit-scrollbar {
  width: 6px;
}

.pending-doc-list::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 4px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .pending-obs-layout {
    flex-direction: column;
    height: auto;
  }

  .pending-obs-left,
  .pending-obs-right {
    width: 100%;
    border-right: none;
    padding-right: 0;
  }

  .pending-doc-list {
    max-height: 260px;
  }

  .pending-preview-frame,
  .pending-preview-empty {
    min-height: 360px;
  }
}

.pending-doc-loading {
  text-align: center;
  font-size: 12px;
  color: #909399;
  padding: 10px 0;
}
</style>
